export const MissingData = ({ noMargin = false, short = false }) => (
  <span style={{ letterSpacing: '5px', margin: noMargin ? 0 : '0 8px' }}>
    {short ? '...' : '...............'}
  </span>
);
